const data = {
  name: '全部',
  getList: '',
  getDetail: '',
  status: null,
  columns: [
    {
      prop: 'index',
      label: '序号',
      width: '30'
    },
    {
      prop: 'brandId',
      label: '品牌名称',
    },
    {
      prop: 'bikeId',
      label: '车辆编号',
    },
    {
      prop: 'abnormalType',
      label: '告警类型',
    },
    {
      prop: 'bikeType',
      label: '车辆类型',
    },
    {
      prop: 'updateTime',
      label: '告警时间',
    },
    {
      prop: 'siteName',
      label: '告警地点',
      width: '200'
    }
  ]
}

export default data
